const CtaBanner = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20large%20industrial%20construction%20project%20Chile%2C%20steel%20structure%20building%20under%20construction%2C%20workers%20on%20site%2C%20dramatic%20wide%20angle%20photography%2C%20professional%20industrial%20construction%2C%20high%20quality%20photorealistic&width=1920&height=600&seq=cta001&orientation=landscape"
          alt="Proyectos de construcción IngemetalSur"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0C1D2E]/90"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight">
          ¿Listo para comenzar<br />tu proyecto?
        </h2>
        <p className="text-white/70 text-lg mb-8 max-w-xl mx-auto">
          Somos la constructora con más experiencia en galpones industriales y obras civiles en todo Chile.
        </p>
        <a
          href="https://wa.me/56992265118?text=Hola%2C%20me%20interesa%20solicitar%20una%20cotizaci%C3%B3n%20para%20un%20proyecto"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-3 bg-[#C88A2A] hover:bg-[#A06B1A] text-white font-bold px-10 py-4 rounded-full transition-all duration-200 text-base whitespace-nowrap hover:scale-[1.03] active:scale-[0.98] hover:shadow-lg"
        >
          <i className="ri-whatsapp-line text-xl"></i>
          Solicitar Cotización Gratis
          <i className="ri-arrow-right-line"></i>
        </a>
        <p className="text-white/40 text-sm mt-4">Respuesta en menos de 24 horas · Sin compromiso</p>
      </div>
    </section>
  );
};

export default CtaBanner;